import CIMDeviceInfoPage from './CIMDeviceInfoPage';

export default CIMDeviceInfoPage;
